import { gql, useMutation } from '@apollo/client';
import { CampaignAlert } from 'modules/campaigns/alerts/types';

const mutation = gql`
  mutation ScheduleCampaignAlerts($campaignId: Long!) {
    scheduleCampaignAlerts(value: $campaignId) {
      metricName
      comparisonOperator
      threshold
      frequency
    }
  }
`;

export type UseScheduleCampaignAlertsResponse = {
  scheduleCampaignAlerts: CampaignAlert[];
};

export type UseScheduleCampaignAlertsVariables = {
  campaignId: number;
};

export const useScheduleCampaignAlertsMutation = () => {
  const [scheduleCampaignAlertsOnly, { loading }] = useMutation<
    UseScheduleCampaignAlertsResponse,
    UseScheduleCampaignAlertsVariables
  >(mutation, {
    notifyOnNetworkStatusChange: true,
  });

  return {
    scheduleCampaignAlertsOnly,
    isLoading: loading,
  };
};
